import ArrowRight from "../../../assets/icons/arrow_right.png";
import TrackPlayer from "../../AudiobooksContainer/TrackPlayer/TrackPlayer";

const AudiobooksSection = (props) => {

    return (
        <section style={{flex: 1.5}}>
            <a href="/audiobooks" className="section-title-link">
                <h2>Livres Audio</h2> 
                <img src={ArrowRight} alt="arrow right" />
            </a>
            <h3>Les derniers livres</h3>
            <div style={{display: 'flex', flexDirection: 'column', gap: '20px'}}>
            {props.trackSelection.map((track, i) => (
                <TrackPlayer
                currentTrack={track}
                key={track.title}
                activeTrackId={props.activeTrackId}
                setActiveTrackId={props.setActiveTrackId}
                onTrackEnd={props.onTrackEnd} 
                isAudiobook={true}
                />
            ))}
            </div>
        </section>
    )
}

export default AudiobooksSection;